export default __webpack_public_path__ + "bff9d9ac2dec8dd23fd4b2ea385cbebe.webp";